import listActions from 'src/modules/asset/list/assetListActions';
import AssetService from 'src/modules/asset/assetService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ASSET_DESTROY';

const assetDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: assetDestroyActions.DESTROY_STARTED,
      });

      await AssetService.destroyAll([id]);

      dispatch({
        type: assetDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.asset.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      getHistory().push('/asset');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      dispatch({
        type: assetDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: assetDestroyActions.DESTROY_ALL_STARTED,
      });

      await AssetService.destroyAll(ids);

      dispatch({
        type: assetDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
        dispatch(listActions.doFetchTemplates());
      }

      Message.success(
        i18n('entities.asset.destroyAll.success'),
      );

      getHistory().push('/asset');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      dispatch({
        type: assetDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default assetDestroyActions;
